import styled from "styled-components";
import React from "react";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH} from "modules";
import {ExternalLink} from "components";
import {ReactComponent as Play} from "assets/images/icons/play.svg";
import {ReactComponent as LockIcon} from "apps/DRAW_PREDICTOR/assets/images/lockBlack.svg";

const Wrapper = styled.div`
	position: sticky;
	bottom: 0;
	width: 100%;
	height: 105px;
	background: #ffffff;
`;

const InnerWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	height: 100%;
	max-width: 1440px;
	margin: 0 auto;
	padding: 0 20px;
	div p svg {
		margin-inline-end: 5px;
		width: 24px;
	}
`;

const ButtonWatch = styled(ExternalLink)`
	color: #fff;
	background: radial-gradient(100% 350.92% at 0% 14.25%, #b6002c 0%, #fa4119 100%);
	border-radius: 50px;
	font-family: Poppins;
	font-weight: 500;
	font-size: 16px;
	line-height: 160%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	min-width: 140px;
	height: 40px;
`;

const Title = styled.p`
	font-family: Qatar2022;
	font-size: 18px;
	line-height: 140%;
	display: flex;
	align-items: center;
`;

const Desc = styled.p`
	font-family: Graphik;
	font-size: 16px;
	line-height: 160%;
	color: #03122b;
`;

export const LockedMessage: React.FC = () => {
	const {t} = useTranslation(LANGUAGE_PATH);

	return (
		<Wrapper>
			<InnerWrapper>
				<div>
					<Title>
						<LockIcon /> {t("pot.locked.no_picks_header")}
					</Title>
					<Desc>{t("pot.locked.body_no_picks")}</Desc>
				</div>
				<ButtonWatch>
					<Play />
					{t("pot.locked.watch")}
				</ButtonWatch>
			</InnerWrapper>
		</Wrapper>
	);
};
